import { render, staticRenderFns } from "./ValidateDowngrade.vue?vue&type=template&id=6c9fc201&"
import script from "./ValidateDowngrade.vue?vue&type=script&lang=js&"
export * from "./ValidateDowngrade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports